<ng-container *ngIf="session" [ngSwitch]="mainService.getShopPortalLayoutKind()">
  <app-thirdparty-shop-boxed-layout *ngSwitchDefault [session]="session"></app-thirdparty-shop-boxed-layout>
  <app-thirdparty-shop-scroll-layout *ngSwitchCase="1" [session]="session"></app-thirdparty-shop-scroll-layout>
</ng-container>